export default __webpack_public_path__ + "static/media/gallery_03.47861b48.jpg";